var exports = {
  "kL": "xdde3148b--bc3e8f--container",
  "_b": "xdde3148b--bc3e8f--left_arrow",
  "$M": "xdde3148b--bc3e8f--right_arrow",
};

module.exports = exports;
